import React, { useState } from 'react';
import ContactForm from './ContactForm';
import JoinForm from './JoinForm';

export default function Contact({ data, socialData }) {
  const { sectionHeading, contactImg } = data;

  // State to toggle between contact and join forms
  const [activeForm, setActiveForm] = useState('contact');

  // Handlers to switch forms
  const showContactForm = () => setActiveForm('contact');
  const showJoinForm = () => setActiveForm('join');

  return (
    <section id="contactus" className="section contactus-section">
      <div className="container">
        <div className="contactus-box rounded overflow-hidden gray-bg">
          <div className="row g-0 p-4 p-lg-5">
            <div className="col-lg-4" />
            <div className="col-lg-8">
              <div
                className="contactus-title"
                data-aos="fade-left"
                data-aos-duration="1200"
                data-aos-delay="200"
              >
                <h5>{sectionHeading.title}</h5>
                <p className="m-0">
                  {/* Add onClick handlers to toggle forms */}
                  <span role="button" onClick={showContactForm} style={activeForm==='contact' ? {color:"yellow"} : {color:"white"}}>Contact Us</span> &nbsp;&nbsp; | &nbsp;&nbsp;
                  <span role="button" onClick={showJoinForm} style={activeForm==='contact' ? {color:"white"} : {color:"yellow"}}>Join Us</span>
                </p>
              </div>
            </div>
          </div>
          <div className="row g-0 contactus-form p-4 p-lg-5 flex-row-reverse">
            <div className="col-lg-8">
              <div className="contact-form">
                {/* Toggle between forms based on activeForm state */}
                {activeForm === 'contact' ? <ContactForm /> : <JoinForm />}
              </div>
            </div>
            <div className="col-lg-4 pe-md-5">
              <div className="contact-banner d-none d-lg-block">
                <img src={contactImg} alt="Avatar" />
              </div>
              {/* Uncomment these if needed */}
              {/* <ContactInfo contactInfoData={contactInfo} />
              <SocialBtns socialBtns={socialData} /> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
